<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th># Factura</th>
          <th>Contraseña</th>
          <th>Serie</th>
          <th>Fecha factura</th>
          <th>Usuario</th>
          <th>Proveedor</th>
          <th>Total Factura</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="factura in facturas.results"
          v-bind:key="factura.id"
          @click="rowClick(factura)"
        >
          <td>{{ factura.documento }}</td>
          <td>{{ factura.recepcion.identificador }}</td>
          <td>{{ factura.serie }}</td>

          <td>{{ factura.fecha_documento }}</td>
          <td>
            <UsuarioEnTablaComponent :current="factura.usuario_obj" />
          </td>
          <td>
            {{ factura.proveedor_obj.codigo }} -
            {{ factura.proveedor_obj.nombre }}
          </td>
          <td>Q {{ factura.total_documento }}</td>

          <td v-if="factura.estado != '9'" class="text-center text-success">
            <span>{{ factura.estado_str }}</span>
          </td>
          <td v-if="factura.estado == '9'" class="text-center text-danger">
            <span>{{ factura.estado_str }}</span>
          </td>
          <td class="text-center"></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  props: ["facturas"],
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      currentPage: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "compras-factura-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "compras-factura-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
